/* eslint-disable import/no-extraneous-dependencies */
import Vue from 'vue';
import {
  Module, VuexModule, MutationAction, Mutation,
} from 'vuex-module-decorators';
import { AxiosRequestConfig } from 'axios';

const vm = new Vue();

@Module({
  namespaced: true,
  name: 'app-data',
})
export default class extends VuexModule {
  apps: AppStore.Release[] = []
  error: Error | null = null;

  @MutationAction({ mutate: ['apps', 'error'] })
  public async fetch(config?: AxiosRequestConfig) {
    try {
      const { data } = await vm.$http.get<AppStore.Apps>({ options: config || undefined });
      return { apps: data.apps, error: null };
    } catch (error) {
      return { apps: [], error };
    }
  }

  @Mutation
  public resetStore() {
    this.error = null;
    this.apps = [];
  }
}
